import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const pages = ["home", "quotazioni", "servizi", "chi-siamo", "recensioni", "faq", "contatti", "privacy", "cookie"];

export default function AdminSEO() {
  const [list, setList] = useState([]);
  const [slug, setSlug] = useState("home");
  const [form, setForm] = useState({ slug: "home", title: "", description: "", keywords: "", og_image: "" });

  const load = () => api.get("/admin/seo").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  useEffect(() => {
    const existing = list.find((s) => s.slug === slug);
    if (existing) setForm(existing);
    else setForm({ slug, title: "", description: "", keywords: "", og_image: "" });
  }, [slug, list]);

  const save = async (e) => {
    e.preventDefault();
    await api.put(`/admin/seo/${slug}`, form);
    toast.success("SEO salvato");
    load();
  };

  return (
    <div data-testid="admin-seo" className="p-10 max-w-4xl">
      <h1 className="font-serif text-4xl text-white mb-2">Gestione SEO</h1>
      <p className="text-white/50 text-sm mb-10">Personalizza titoli, descrizioni e keywords per ogni pagina.</p>

      <div className="flex gap-2 mb-6 flex-wrap">
        {pages.map((p) => (
          <button key={p} onClick={() => setSlug(p)} className={`px-3 py-1.5 text-xs uppercase tracking-widest border ${slug === p ? "border-[var(--gold)] text-[var(--gold)]" : "border-white/15 text-white/60"}`}>
            {p}
          </button>
        ))}
      </div>

      <form onSubmit={save} className="luxe-card p-6 space-y-4">
        <label className="block">
          <span className="text-xs uppercase tracking-widest text-white/40">Titolo (max 60 caratteri)</span>
          <input required maxLength={60} value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="mt-2 w-full bg-transparent border border-white/15 px-4 py-2.5 text-white focus:border-[var(--gold)] outline-none" />
        </label>
        <label className="block">
          <span className="text-xs uppercase tracking-widest text-white/40">Description (max 160)</span>
          <textarea required maxLength={160} rows={3} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="mt-2 w-full bg-transparent border border-white/15 px-4 py-2.5 text-white focus:border-[var(--gold)] outline-none" />
        </label>
        <label className="block">
          <span className="text-xs uppercase tracking-widest text-white/40">Keywords (separati da virgola)</span>
          <input value={form.keywords} onChange={(e) => setForm({ ...form, keywords: e.target.value })} className="mt-2 w-full bg-transparent border border-white/15 px-4 py-2.5 text-white focus:border-[var(--gold)] outline-none" />
        </label>
        <label className="block">
          <span className="text-xs uppercase tracking-widest text-white/40">OG Image URL</span>
          <input value={form.og_image} onChange={(e) => setForm({ ...form, og_image: e.target.value })} className="mt-2 w-full bg-transparent border border-white/15 px-4 py-2.5 text-white focus:border-[var(--gold)] outline-none" />
        </label>
        <button type="submit" className="btn-gold">Salva SEO</button>
      </form>
    </div>
  );
}
